import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePlanReviewSubmissionTypeMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  set: Types.Plan_Review_Submission_Types_Set_Input;
}>;


export type UpdatePlanReviewSubmissionTypeMutation = { __typename?: 'mutation_root', update_plan_review_submission_types_by_pk?: { __typename?: 'plan_review_submission_types', id: any } | null };


export const UpdatePlanReviewSubmissionTypeDocument = gql`
    mutation updatePlanReviewSubmissionType($id: uuid!, $set: plan_review_submission_types_set_input!) {
  update_plan_review_submission_types_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;
export type UpdatePlanReviewSubmissionTypeMutationFn = Apollo.MutationFunction<UpdatePlanReviewSubmissionTypeMutation, UpdatePlanReviewSubmissionTypeMutationVariables>;

/**
 * __useUpdatePlanReviewSubmissionTypeMutation__
 *
 * To run a mutation, you first call `useUpdatePlanReviewSubmissionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanReviewSubmissionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanReviewSubmissionTypeMutation, { data, loading, error }] = useUpdatePlanReviewSubmissionTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdatePlanReviewSubmissionTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanReviewSubmissionTypeMutation, UpdatePlanReviewSubmissionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanReviewSubmissionTypeMutation, UpdatePlanReviewSubmissionTypeMutationVariables>(UpdatePlanReviewSubmissionTypeDocument, options);
      }
export type UpdatePlanReviewSubmissionTypeMutationHookResult = ReturnType<typeof useUpdatePlanReviewSubmissionTypeMutation>;
export type UpdatePlanReviewSubmissionTypeMutationResult = Apollo.MutationResult<UpdatePlanReviewSubmissionTypeMutation>;
export type UpdatePlanReviewSubmissionTypeMutationOptions = Apollo.BaseMutationOptions<UpdatePlanReviewSubmissionTypeMutation, UpdatePlanReviewSubmissionTypeMutationVariables>;